/**
 * Cena za km przewoźnika na relacji — kształt z API (`carriers/relation-price.ts`).
 * Kolumna „$” przy zleceniu i kierunki w profilu przewoźnika (06.10.2026).
 */
export interface PricePerKm {
  /** zł/km; `null` = brak ceny, powód w `reason`. */
  pln: number | null;
  /** Z ilu frachtów policzono. */
  freights: number;
  reason: string | null;
  /** Opis rachunku do podpowiedzi. */
  description: string | null;
}

/** „2,41 zł/km (7)” — dwa miejsca po przecinku, w nawiasie liczba frachtów. */
export function formatPricePerKm(p: PricePerKm): string {
  const value = (p.pln ?? 0).toLocaleString('pl-PL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${value} zł/km (${p.freights})`;
}
